<template>
    <el-dialog
        v-if="visible"
        :visible="visible"
        :show-close="false"
        width="560px"
        :close-on-click-modal="false"
        :destroy-on-close="true"
    >
        <div class="dialog">
            <dialogHeader
                title="删除退款失败记录"
                @closeDialog="handleCancel"
            ></dialogHeader>
            <div class="dialogList">
                <p class="delete-tip">
                    删除后该条失败记录的退款金额将被释放，可重新发起退款。该操作不可恢复，是否确认删除？
                </p>
                <el-descriptions
                    :column="1"
                    size="small"
                    border
                    class="deleteInfo"
                >
                    <el-descriptions-item label="系统退款订单号">
                        {{ refundInfo.refund_id }}
                    </el-descriptions-item>
                    <el-descriptions-item label="退款金额">
                        {{ refundInfo.refund_money | $toyun }} 元
                    </el-descriptions-item>
                    <el-descriptions-item label="退款原因">
                        {{ refundInfo.refund_info }}
                    </el-descriptions-item>
                    <el-descriptions-item label="退款结果">
                        {{ refundInfo.result_msg }}
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
                flex="cross:center main:right"
            >
                <el-button size="small" @click="handleCancel(false, $event)">
                    取消
                </el-button>
                <el-button
                    type="danger"
                    size="small"
                    :loading="saveLoading"
                    @click="handleConfirm"
                >
                    删除
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { deleteRefundLog } from "@/api/order";

export default {
    name: "deleteRefundDialog",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        refundInfo: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            saveLoading: false,
        };
    },
    methods: {
        handleCancel(needRefresh = false) {
            this.$emit("update:visible", false);
            needRefresh && this.$emit("refresh");
        },
        async handleConfirm() {
            this.saveLoading = true;
            const res = await deleteRefundLog({
                refund_id: this.refundInfo.id,
            }).catch((e) => {
                this.saveLoading = false;
            });
            this.saveLoading = false;
            if (res && res.code == 200) {
                this.handleCancel(true);
                this.$message.success("删除成功，可重新发起退款");
            } else if (res) {
                this.$message.error(res.msg);
            }
        },
    },
};
</script>

<style lang="scss">
.delete-tip {
    padding: 6px 0 16px;
    line-height: 22px;
    color: #f56c6c;
}
.deleteInfo {
    .el-descriptions__label {
        width: 130px;
        color: #606266;
    }
}
</style>
